import { useGetDtoolsAuthDetails } from 'src/graphql/entities/integrations/dtools/hooks/use-get-dtools-auth-details';
import { DtoolsAuthDetails } from './dtools-auth-details';
import { DtoolsConnectIntegration } from './dtools-connect-integration';

export const DtoolsIntegrationView = () => {
  const { dtoolsAuthDetails, hasStoredKey, loading } = useGetDtoolsAuthDetails();

  if (hasStoredKey && !loading && dtoolsAuthDetails) {
    return <DtoolsAuthDetails id={dtoolsAuthDetails.id} />;
  }

  return <DtoolsConnectIntegration />;
};
